import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=13b4c5e4&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=13b4c5e4&prod&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=13b4c5e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4c5e4",
  null
  
)

export default component.exports